module.exports = __webpack_public_path__ + "img/DW365-356.38464446.jpg";